import { all, call, put, takeLatest } from 'redux-saga/effects';
import { AnyAction } from 'redux';

import * as constants from 'redux/constants/divorces.constants';
import {
  getAll,
  getForm,
  getOne,
  save,
  softDelete,
  softDeleteFile,
} from 'services/divorces.services';

export function* divorcesDelete(action: AnyAction): Generator {
  try {
    const { id } = action;
    const { data }: any = yield call(softDelete, id);
    yield put({
      type: constants.DIVORCES_ON_DELETE_SUCCEEDED,
      data: { ...data, id },
    });
  } catch (error) {
    yield put({ type: constants.DIVORCES_ON_DELETE_FAILED, error });
  }
}

export function* divorcesFileDelete(action: AnyAction): Generator {
  try {
    const { id, fileId }: any = action;
    const { data }: any = yield call(softDeleteFile, id, fileId);
    yield put({
      type: constants.DIVORCES_ON_DELETE_FILE_SUCCEEDED,
      data: { ...data, id, fileId },
    });
  } catch (error) {
    yield put({ type: constants.DIVORCES_ON_DELETE_FILE_FAILED, error });
  }
}

export function* divorcesGetAll(action: AnyAction): Generator {
  try {
    const { limit, page, search, sortKey, sortType } = action;
    const { data }: any = yield call(getAll, limit, page, search, sortKey, sortType);
    yield put({
      type: constants.DIVORCES_ON_GET_ALL_SUCCEEDED,
      data,
    });
  } catch (error) {
    yield put({ type: constants.DIVORCES_ON_GET_ALL_FAILED, error });
  }
}

export function* divorcesGetForm(): Generator {
  try {
    const { data }: any = yield call(getForm);
    yield put({ type: constants.DIVORCES_ON_GET_FORM_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.DIVORCES_ON_GET_FORM_FAILED, error });
  }
}

export function* divorcesGetOne(action: AnyAction): Generator {
  try {
    const { id } = action;
    if (id) {
      const { data }: any = yield call(getOne, id);
      yield put({ type: constants.DIVORCES_ON_GET_ONE_SUCCEEDED, data });
    }
  } catch (error) {
    yield put({ type: constants.DIVORCES_ON_GET_ONE_FAILED, error });
  }
}

export function* divorcesSave(action: AnyAction): Generator {
  try {
    const { formData, id } = action;
    const { data }: any = yield call(save, formData, id);
    yield put({ type: constants.DIVORCES_ON_SAVE_SUCCEEDED, data });
  } catch (error) {
    yield put({ type: constants.DIVORCES_ON_SAVE_FAILED, error });
  }
}

export function* watchDivorces(): Generator {
  yield all([
    takeLatest(constants.DIVORCES_ON_DELETE_REQUESTED, divorcesDelete),
    takeLatest(constants.DIVORCES_ON_DELETE_FILE_REQUESTED, divorcesFileDelete),
    takeLatest(constants.DIVORCES_ON_GET_ALL_REQUESTED, divorcesGetAll),
    takeLatest(constants.DIVORCES_ON_GET_FORM_REQUESTED, divorcesGetForm),
    takeLatest(constants.DIVORCES_ON_GET_ONE_REQUESTED, divorcesGetOne),
    takeLatest(constants.DIVORCES_ON_SAVE_REQUESTED, divorcesSave),
  ]);
}
